import { useMantineTheme } from "@mantine/core"
import { useMediaQuery, UseMediaQueryOptions } from "@mantine/hooks"

interface IMediaQueryOption {
  defaultValue: true | false | undefined
  options: UseMediaQueryOptions
}

interface IMediaQueryOptions {
  xs?: IMediaQueryOption
  sm?: IMediaQueryOption
  md?: IMediaQueryOption
  lg?: IMediaQueryOption
  xl?: IMediaQueryOption
  xxl?: IMediaQueryOption
  xxxl?: IMediaQueryOption
}

type ActiveBreakpoint = keyof IMediaQueryOptions | "none"

export function useBreakpoints(options?: IMediaQueryOptions) {
  const { breakpoints } = useMantineTheme()

  const xs = useMediaQuery(
    `(max-width: ${breakpoints.sm}) `,
    options?.xs?.defaultValue,
    options?.xs?.options
  )
  const sm = useMediaQuery(
    `(min-width: ${breakpoints.sm}) and (max-width: ${breakpoints.md})`,
    options?.sm?.defaultValue,
    options?.sm?.options
  )
  const md = useMediaQuery(
    `(min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg})`,
    options?.md?.defaultValue,
    options?.md?.options
  )
  const lg = useMediaQuery(
    `(min-width: ${breakpoints.lg}) and (max-width: ${breakpoints.xl})`,
    options?.lg?.defaultValue,
    options?.lg?.options
  )
  const xl = useMediaQuery(
    `(min-width: ${breakpoints.xl}) and (max-width: ${breakpoints.xxl})`,
    options?.xl?.defaultValue,
    options?.xl?.options
  )
  const xxl = useMediaQuery(
    `(min-width: ${breakpoints.xxl}) and (max-width: ${breakpoints.xxxl})`,
    options?.xxl?.defaultValue,
    options?.xxl?.options
  )
  const xxxl = useMediaQuery(
    `(min-width: ${breakpoints.xxxl})`,
    options?.xxxl?.defaultValue,
    options?.xxxl?.options
  )
  return {
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
    xxxl,
    active: (xs
      ? "xs"
      : sm
        ? "sm"
        : md
          ? "md"
          : lg
            ? "lg"
            : xl
              ? "xl"
              : xxl
                ? "xxl"
                : xxxl
                  ? "xxxl"
                  : "none") as ActiveBreakpoint,
  }
}
